enum HTTPStatus {
  OK = 200,
  NoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
}

export default HTTPStatus
